export const deClientPortalNewsFromEinwertWidget = {
    title: 'Neues von einwert',
    introLineOne: 'Testen Sie erste Versionen unserer neuen Features, bevor sie in die Plattform eingegliedert werden.',
    introLineTwo: 'Geben Sie Feedback, damit wir sie weiter verbessern können!',
    cards: {
        pdfToValXml: {
            title: 'PDF zu ValXML',
            text: 'Generieren Sie in wenigen Minuten ValXML-Dateien aus Ihren Gutachten im PDF-Format.',
        },
        autoPlausibility: {
            title: 'Auto-Plausibilisierung',
            text: 'Überprüfen Sie KI-gestützt Gutachten mit Standard-Checks und Ihren eigenen Fragen.',
        },
        tenantListImport: {
            title: 'Mieterliste zu Excel',
            text: 'Lesen Sie Mieterdaten aus Excel oder PDF aus und exportieren Sie diese im einwert-Format.',
        },
        soonAvailable: {
            title: 'Bald verfügbar',
            text: 'Wir arbeiten stetig an der Verbesserung der Beta-Features, sowie der Entwicklung weiterer KI-Tools. Bleiben Sie gespannt!',
        },
    },
    betaLabel: 'Beta',
    tryLabel: 'Testen',
    disclaimer: 'Unsere Tools verwenden KI und liefern nicht immer verlässliche Ergebnisse. Bitte prüfen Sie die Ergebnisse sorgfältig.',
}
